<ion-router-outlet></ion-router-outlet>

<div *ngIf="isDevelopmentOrStaging()"
    [class]="env.name === 'development' ? 'fixed text-center bottom-0 left-0 mr-2 py-1 px-4 bg-green-500 text-white text-xs font-bold border-green-500 border-2 rounded-tr-lg hover:bg-green-700 cursor-pointer shadow-t-lg' : 'fixed text-center bottom-0 left-0 mr-2 py-1 px-4 bg-orange-500 text-white text-xs font-bold border-orange-500 border-2 rounded-tr-lg hover:bg-orange-700 cursor-pointer shadow-t-lg'">

    {{ env.name.toUpperCase() }}<br />
    {{ env.version }}
</div>
